import { defineNuxtPlugin } from '#app'

declare global {
  interface Window {
    grecaptcha: Grecaptcha | undefined
  }
}

interface Grecaptcha {
  ready: (callback: () => void) => void
  render: (elementId: string, options: { sitekey: string; callback: (token: string) => void }) => void
  execute: (sitekey: string, options: { action: string }) => Promise<string>
}

export default defineNuxtPlugin(nuxtApp => {
  const siteKey = useRuntimeConfig().public.googleRecaptchaKey

  // Function to dynamically load the reCAPTCHA script
  function loadRecaptchaScript(): Promise<Grecaptcha> {
    if (document.getElementById('recaptcha-script')) {
      return Promise.resolve(window.grecaptcha as Grecaptcha)
    }

    // Create the script tag for reCAPTCHA
    const script = document.createElement('script')
    script.id = 'recaptcha-script'
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
    script.async = true
    script.defer = true

    return new Promise((resolve, reject) => {
      script.onload = () => window.grecaptcha ? resolve(window.grecaptcha) : reject('reCAPTCHA failed to load.')
      script.onerror = () => reject('Failed to load reCAPTCHA script.')
      document.head.appendChild(script)
    })
  }

  // Initialize the reCAPTCHA
  loadRecaptchaScript().then(grecaptcha => {
    nuxtApp.provide('recaptcha', {
      render: (elementId: string, callback: (token: string) => void) =>
        grecaptcha.ready(() => grecaptcha.render(elementId, { sitekey: siteKey, callback })),
      execute: (action: string, callback: (token: string) => void) =>
        grecaptcha.ready(() => grecaptcha.execute(siteKey, { action }).then(callback)),
    })
  }).catch(error => console.error(error))
})
